export default "__VITE_ASSET__CcIuC6Fx__"